import { useStyletron } from "baseui";
import { Hide } from "baseui/icon";
import {  LabelMedium, ParagraphMedium } from "baseui/typography";
import React from "react";

export default function EmptyState(props: { header: string, message?: string, icon?: React.ReactElement, children?: any }) {
  const [css, theme] = useStyletron();

  return (
    <div
      className={css({
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      })}
    >
      <div
        className={css({
          alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
          opacity: 0.5
        })}
      >
        {!props.icon && <Hide color={theme.colors.contentTertiary} size={theme.sizing.scale800} />}
        {props.icon && <>{React.cloneElement(props.icon, { size: theme.sizing.scale800, color: theme.colors.contentTertiary })}</>}
        <LabelMedium className={css({ color: theme.colors.contentTertiary, marginBottom: theme.sizing.scale200, marginTop: theme.sizing.scale400 })}>{props.header}</LabelMedium>
        {props.message && <ParagraphMedium className={css({ color: theme.colors.contentTertiary })}>{props.message}</ParagraphMedium>}
      </div>
      {props.children}
    </div>
  );
}